import { useEffect, useState } from 'react';
import { recordBriefOpen } from '../api/client';
import type { BriefPayload } from '../api/types';
import { useAuthContext } from '../auth/AuthContext';
import { BriefNote } from './BriefNote';
import { formatShortDay } from '../lib/format.ts';

// The morning brief (P4-05): one short note from Scout, written from the day's facts and checked
// against the last week's notes. The facts behind it stay on the board; the note only links to them.
export function BriefPanel({
  brief,
  onOpenAccount,
}: {
  brief: BriefPayload | null;
  onOpenAccount: (accountId: string) => void;
}) {
  const { getToken } = useAuthContext();
  const [recordedOpen, setRecordedOpen] = useState(false);
  const body = brief?.body_markdown ?? '';
  const hasNote = Boolean(brief?.brief_on && body.trim());

  useEffect(() => {
    // The note is always shown, so showing it is the open.
    if (!hasNote || recordedOpen) return;
    setRecordedOpen(true);
    void recordBriefOpen(getToken);
  }, [hasNote, recordedOpen, getToken]);

  const waiting = brief?.picks_waiting;
  return (
    <section className="briefpanel morningbrief" aria-label="Morning brief">
      <div className="briefbar">
        <h3 className="brieftitle">Morning brief</h3>
        {brief?.brief_on ? <span className="briefday">{formatShortDay(brief.brief_on)}</span> : null}
      </div>
      {hasNote
        ? <BriefNote body={body} onOpenAccount={onOpenAccount} />
        : <p className="briefempty">Your brief is not ready yet. You can work from your book below.</p>}
      {waiting != null && waiting > 0 ? (
        <p className="briefwait">{waiting} recommendations awaiting admin or leadership approval</p>
      ) : null}
    </section>
  );
}
